// src/components/ThemeToggleButton.js
import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { useColorMode } from "../theme/CustomThemeProvider"; 

const ThemeToggleButton = () => {
  const theme = useTheme();
  const { toggleColorMode } = useColorMode();

  return (
    <Tooltip title={theme.palette.mode === "dark" ? "Light mode" : "Dark mode"}>
      <IconButton
        color="inherit"
        onClick={toggleColorMode}
        sx={{ ml: 1 }}
        aria-label="toggle theme"
      >
        {theme.palette.mode === "dark" ? <Brightness7 /> : <Brightness4 />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggleButton;
